export default "__VITE_ASSET__BNoi2MbQ__"